import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class RateServicesClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getServicesVoiceTrunks() {
    return this.http.get('voice');
  }

  getServicesVoiceVerification(user_id) {
    return this.pure_http.get(`users/${user_id}/number-verification-rates`);
    // return this.http.get('number-verification/voice');
  }

  // не используется, пока на бэкенде не сделаем нормальную логику для транков
  getServicesVoiceVerificationTrunks() {
    return this.http.get('number-verification/voice');
  }

  getVoicePricesByTrunk(trunk_id, params) {
    return this.http.get(`voice/${trunk_id}/prices`, { params });
  }

  // не используется, пока на бэкенде не сделаем нормальную логику для транков
  getVoiceVerificationPricesByTrunk(trunk_id, params) {
    return this.http.get(`number-verification/voice/${trunk_id}/prices`, { params });
  }

  getVoiceVerificationPricesByRate(user_id, rate_id, params) {
    return this.pure_http.get(`users/${user_id}/number-verification-rates/${rate_id}/prices`, {
      params
    });
  }

  getSmsVerificationPrices(params) {
    return this.http.get('number-verification/sms/prices', { params });
  }

  getSmsPrices(params) {
    return this.http.get('sms/prices', { params });
  }

  getHlrPrices(params) {
    return this.http.get('hlr/prices', { params });
  }
}

export const RateService = new RateServicesClass({
  api_version: 3,
  resource: 'services'
});
